import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import AppCard from 'components/AppCard';
import PartialPageSpinner from 'components/PartialPageSpinner';
import useAuth from 'hooks/useAuth';
import useResponsive from 'hooks/useResponsive';
import { useTranslation } from 'react-i18next';
import { SCHEDULE_NOW_MEETING_URL, SUPPORT_URL } from 'routes/paths';
import Page from '../../../components/Page';
import useSettings from '../../../hooks/useSettings';
import { useAppListing } from 'api/ApiHooks/GeneralHooks';
import usePortalId from 'hooks/portal/usePortalId';
import { useEffect, useMemo, useState } from 'react';

export default function EcommerceProductList() {
  const { t } = useTranslation();
  const portalId = usePortalId();
  const { user } = useAuth();
  const { themeStretch } = useSettings();
  const smUp = useResponsive('up', 'sm');
  const { data } = useAppListing(Number(portalId));
  const [open, setOpen] = useState(false);

  if (data === undefined) {
    return <PartialPageSpinner />;
  }
  const appList = data?.data;

  return (
    <>
      <Page title={t('dashboard')}>
        <Container maxWidth={themeStretch ? false : 'xl'}>
          <Card sx={{ backgroundColor: '#CCF1FF', marginBottom: '32px' }}>
            <CardContent
              sx={{
                padding: '16px 32px',
                color: 'grey.800',
              }}
            >
              <Box>
                <Grid>
                  <Typography
                    gutterBottom
                    variant='h4'
                    className='custom-h4'
                    sx={{ wordWrap: 'break-word' }}
                  >
                    {t('need_help')}, {user?.email}?
                  </Typography>
                  <Stack width='80%'>
                    <Typography variant='body2'>
                      {t('schedule_meeting')}
                      {/* <Button
                        variant='text'
                        sx={{ textDecoration: 'underline' }}
                        onClick={() => {
                          meetingPopup();
                        }}
                      >
                        {' - '}
                        {t('schedule_now')}
                      </Button> */}
                    </Typography>
                  </Stack>
                </Grid>
                <Button
                  variant='contained'
                  className='schedule-element'
                  onClick={() => setOpen(true)}
                  sx={
                    smUp
                      ? {
                          position: 'absolute',
                          right: 32,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: '#2196F3',
                        }
                      : {
                          position: 'unset',
                          display: 'flex',
                          flexDirection: 'column',
                          marginTop: '40px',
                          right: 32,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: '#2196F3',
                        }
                  }
                >
                  {t('schedule_a_meeting')}
                </Button>
              </Box>
            </CardContent>
          </Card>
          <Grid
            sx={{
              display: 'flex',
              flexDirection: smUp ? 'row' : 'column',
              flexWrap: 'wrap',
            }}
          >
            <Card
              sx={{
                width: '100%',
                padding: '24px',
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                >
                  {appList.map((app, index) => {
                    return <AppCard row={app} key={index} />;
                  })}
                  <Box
                    sx={{
                      width: smUp ? '65%' : '100%',
                    }}
                  >
                    <Box
                      sx={{
                        pt: 4,
                        pl: smUp ? 4 : 2,
                        // mx: 'auto',
                        textAlign: 'center',
                        mt: smUp ? 8 : '',
                      }}
                    >
                      <iframe
                        width={smUp ? '560' : 'auto'}
                        height={smUp ? '315' : 'auto'}
                        src='https://www.youtube.com/embed/ALsHxN02Z4k'
                        title='YouTube video player'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        // allowfullscreen
                      ></iframe>
                    </Box>
                    <div
                      style={{
                        padding: '16px',
                        marginLeft: smUp ? '50px' : '20px',
                        marginTop: '25px',
                        borderRadius: '12px',
                        background: '#CCF1FF',
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '10px',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#212B36',
                          }}
                        >
                          Festive Momentum To New Year – FREE HubSpot Audit +
                          Setup
                        </span>
                        {(() => {
                          const Countdown = () => {
                            const target = useMemo(
                              () => new Date('2026-01-15T00:00:00'),
                              []
                            );
                            const [now, setNow] = useState<Date>(
                              () => new Date()
                            );

                            useEffect(() => {
                              const id = setInterval(
                                () => setNow(new Date()),
                                1000
                              );

                              return () => clearInterval(id);
                            }, []);

                            const diffMs = Math.max(
                              0,
                              target.getTime() - now.getTime()
                            );
                            const totalSec = Math.floor(diffMs / 1000);
                            const days = Math.floor(totalSec / 86400);
                            const hours = Math.floor((totalSec % 86400) / 3600);
                            const mins = Math.floor((totalSec % 3600) / 60);
                            const secs = totalSec % 60;
                            const pad = (n: number) =>
                              String(n).padStart(2, '0');

                            return (
                              <div
                                style={{
                                  display: 'flex',
                                  maxWidth: 'fit-content',
                                  background: '#ffffff',
                                  alignItems: 'center',
                                  gap: '10px',
                                  borderRadius: '8px',
                                  padding: '6px 10px',
                                  fontSize: '16px',
                                  fontWeight: '600',
                                  marginTop: '10px',
                                  color: '#212B36',
                                }}
                              >
                                <span>{days}</span>
                                <span>:</span>
                                <span>{pad(hours)}</span>
                                <span>:</span>
                                <span>{pad(mins)}</span>
                                <span>:</span>
                                <span>{pad(secs)}</span>
                              </div>
                            );
                          };

                          return <Countdown />;
                        })()}
                      </div>
                      <button
                        style={{
                          color: '#fff',
                          background: '#2196F3',
                          border: '1px solid #2196F3',
                          padding: '10px 16px',
                          borderRadius: '8px',
                          fontSize: '16px',
                          fontWeight: '600',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          window.open(
                            'https://makewebbetter.com/festive-offer/?utm_source=automatedcoupon-app-main&utm_medium=top-strip&utm_campaign=festive-offer-27-2025',
                            '_blank'
                          )
                        }
                      >
                        Claim now
                      </button>
                    </div>
                  </Box>
                </Grid>
              </Box>
            </Card>
          </Grid>
        </Container>
      </Page>
      <Dialog
        open={open}
        maxWidth={false}
        keepMounted
        onClose={() => setOpen(false)}
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle>{t('schedule_a_meeting')}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-slide-description'>
            <iframe
              src={SCHEDULE_NOW_MEETING_URL}
              style={{
                border: 0,
                width: smUp ? '560px' : 'auto',
                height: '80vh',
                paddingBottom: '25px',
                borderRadius: '8px',
              }}
              title='MakeWebBetter Scheduling'
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
